import type { ChatSuggestion } from "@repo/app-types/entities/liveCoaching";
import type { FC } from "react";
import { GridList, GridListItem } from "react-aria-components";

export interface ChatSuggestionsWidgetProps {
  chatSuggestions: readonly ChatSuggestion[];
  onChatSuggestionClick: (suggestion: ChatSuggestion) => void;
}

export const ChatSuggestionsWidget: FC<ChatSuggestionsWidgetProps> = (
  props,
) => {
  return (
    <GridList
      aria-label="Suggested questions"
      className="flex gap-1.5 overflow-x-auto"
      items={props.chatSuggestions}
      selectionMode="none"
    >
      {(suggestion) => (
        <GridListItem
          onAction={() => props.onChatSuggestionClick(suggestion)}
          className="shrink-0 cursor-pointer rounded-full border border-border-light bg-white px-2.5 py-1 text-[11px] leading-4 font-medium text-slate-600 transition-colors hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-700"
        >
          {suggestion.title}
        </GridListItem>
      )}
    </GridList>
  );
};
